import React, { useContext } from 'react';
import {
  CentralProviderContext, CentralProviderHeader, CurrentLocationAvatar,
} from '@michelin/central-provider';
import { runningOnCanvas } from '@michelin/central-provider/dist/utils/canvas';
import { AccountLevel } from '@michelin/central-provider/dist/compositions/CustomerList/CustomerList';

function useGetAccountSelectorLevels() {
  const { hasFullAccountAccess, centralProfile } = useContext(CentralProviderContext);
  const accountSelectorLevels: AccountLevel[] = [];
  const customerTypes: Set<string> = new Set();
  if (!centralProfile || !centralProfile.grants) return [];

  if (hasFullAccountAccess('providers')) {
    accountSelectorLevels.push('BT');
  } else {
    centralProfile.grants.forEach((g) => {
      g.accounts.forEach((l) => customerTypes.add(l.customer_type.toLocaleUpperCase()));
    });
    if (customerTypes.has('ST')) {
      accountSelectorLevels.push('ST');
    } else {
      accountSelectorLevels.push('BT');
    }
  }
  return accountSelectorLevels;
}

export function Heading() {
  const { centralProfile } = useContext(CentralProviderContext);
  const accountSelectorLevels = useGetAccountSelectorLevels();

  if (!centralProfile || !centralProfile.grants) return null;

  return (
    <div style={{ display: runningOnCanvas() ? 'none' : undefined }}>
      <CentralProviderHeader
        appTitle="Service Provider Profiles"
        logoType="michelin"
        customLink={(
          <CurrentLocationAvatar
            allowedAccountTypes="provider"
            accountSelectorLevels={accountSelectorLevels}
            allowedCountryCodes={['US', 'CA']}
            enableStateFiltering
          />
      )}
      />
    </div>
  );
}
